// extracted by mini-css-extract-plugin
export default {"tabWrapper":"HistoryCheckParameter_tabWrapper__DosBc"};